import { createContext } from 'preact/compat';
export const newsletterRegistrationDefaults = {
    backgroundImageUrl: 'https://via.placehold.co/2480x1000/png',
    title: 'Stay up to date with SnowDome Promotions!',
    copy: 'Pop your email below to make sure you never miss a tasty SnowDome Promotion!',
};
export const NewsletterCTX = createContext(newsletterRegistrationDefaults);
